import type { RegionsTranslation } from './types'

/**
 * English translations for Regions domain
 */
export const regionsTranslationEn: RegionsTranslation = {
  // Page/Section level
  title: 'Regions',
  subtitle: 'Manage geographic regions and their factory assignments',

  // Actions
  addRegion: 'Add Region',
  editRegion: 'Edit Region',
  deleteRegion: 'Delete Region',

  // Drawer Headers
  addRegionDescription: 'Fill in the details to create a new region',
  editRegionDescription: 'Update the region details below',
  viewRegionDescription: 'View region information and assignments',

  // Search and states
  searchPlaceholder: 'Search regions...',
  noRegions: 'No Regions Found',
  noRegionsDescription:
    'No regions have been configured yet. Add your first region to start managing geographic areas.',
  addFirst: 'Add Your First Region',

  // Form fields
  code: 'Region Code',
  codePlaceholder: 'e.g., CENTRAL, EASTERN',
  name: 'Region Name',
  namePlaceholder: 'e.g., Central Region',
  description: 'Description',
  descriptionPlaceholder: 'Enter region description (optional)',
  country: 'Country',
  selectCountry: 'Select country',
  factories: 'Assigned Factories',
  selectFactories: 'Select factories to assign',
  noFactoriesSelected: 'No factories assigned',
  status: 'Status',

  // Status values
  active: 'Active',
  inactive: 'Inactive',
  all: 'All',

  // Stats
  totalRegions: 'Total Regions',
  activeRegions: 'Active',
  inactiveRegions: 'Inactive',
  factoriesCount: 'Factories',
  citiesCount: 'Cities',

  // Table headers
  table: {
    code: 'Code',
    name: 'Name',
    country: 'Country',
    factories: 'Factories',
    cities: 'Cities',
    status: 'Status',
    actions: 'Actions',
  },

  // Card content
  card: {
    factories: 'Factories',
    cities: 'Cities',
    noFactories: 'No factories assigned',
    noCities: 'No cities linked',
  },

  // Messages
  messages: {
    createSuccess: 'Region Created',
    createSuccessDescription: 'The new region has been created successfully.',
    updateSuccess: 'Region Updated',
    updateSuccessDescription: 'The region has been updated successfully.',
    deleteSuccess: 'Region Deleted',
    deleteSuccessDescription: 'The region has been removed.',
    deleteConfirm: 'Delete Region',
    deleteConfirmDescription:
      'Are you sure you want to delete this region? This may affect customer address restrictions.',
    loadError: 'Failed to load regions. Please try again.',
  },

  // Validation
  validation: {
    codeRequired: 'Region code is required',
    codeInvalid: 'Region code must be alphanumeric and uppercase',
    nameRequired: 'Region name is required',
  },

  // Filter
  filter: {
    all: 'All Status',
    active: 'Active Only',
    inactive: 'Inactive Only',
    byCountry: 'Filter by Country',
  },
}
